export default "__VITE_ASSET__CVUHK29l__"